import { render, staticRenderFns } from "./BlocoRegularizacao.vue?vue&type=template&id=776a243c&scoped=true&lang=pug"
import script from "./BlocoRegularizacao.vue?vue&type=script&lang=js"
export * from "./BlocoRegularizacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoRegularizacao.vue?vue&type=style&index=0&id=776a243c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a243c",
  null
  
)

export default component.exports